import { Button, Typography } from 'antd';
import * as React from 'react';
import { Link } from 'react-router-dom';

import { ForbiddenStub } from 'assets/images';
import { MainLayout } from 'components/layouts';
import { Spacing } from 'components/ui';
import { routes } from 'config/routes';

import s from './ForbiddenErrorPage.module.scss';
import { FORBIDDEN_ERROR_PAGE_TEXTS } from './texts';

const ForbiddenErrorPage: React.FC = () => {
  return (
    <MainLayout>
      <section className={s.forbiddenErrorPage}>
        <ForbiddenStub className={s.forbiddenErrorPage__img} />
        <Typography.Text className={s.forbiddenErrorPage__text}>
          {FORBIDDEN_ERROR_PAGE_TEXTS.NO_ACCESS}
        </Typography.Text>
        <Spacing.RowItem className={s.forbiddenErrorPage__button}>
          <Link to={routes.form.createPath()}>
            <Button type="primary">{FORBIDDEN_ERROR_PAGE_TEXTS.GO_BACK}</Button>
          </Link>
        </Spacing.RowItem>
      </section>
    </MainLayout>
  );
};

export default React.memo(ForbiddenErrorPage);
